import { useGLTF } from '@react-three/drei'
import { useFrame, useGraph } from '@react-three/fiber'
import { useMemo, useRef } from 'react'
import { SkeletonUtils } from 'three-stdlib'
import Moon from '../meshes/Moon'

export default function MinigameStar2({ index, star, position, onClick, shakeUntil = 0, opacity = 1, moonOpacity = 1, shakeIntensity = 0.45 }) {
	const groupRef = useRef()
	const { scene } = useGLTF('/models/star.glb')
	const clone = useMemo(() => SkeletonUtils.clone(scene), [scene])
	const { nodes } = useGraph(clone)
	const isBigStar = star.type === 'bigStar'
	 const isMoon = star.type === 'moon'
	 const color = star.type === 'purpleStar' ? '#c026d3' : 'yellow'

	useFrame(({ clock }) => {
		if (!groupRef.current) return

		const offset = Date.now() < shakeUntil
			? Math.sin(clock.elapsedTime * 5 + index * 0.6) * shakeIntensity
			: 0
		groupRef.current.position.set(position[0] + offset, position[1], position[2])
	})

	return (
		<group ref={groupRef} position={position} scale={isMoon ? 0.55 : isBigStar ? 1.8 : 0.9}>
			{isMoon ? <group>
				<Moon key={`moon-${moonOpacity}`} position={[0, 0, 0]} scale={1} shiny opacity={moonOpacity} />
				<mesh rotation={[-Math.PI / 2, 0, 0]} onPointerDown={onClick}>
					<circleGeometry args={[2.15, 32]} />
					<meshBasicMaterial transparent opacity={0} depthWrite={false} />
				</mesh>
			</group> : <mesh
				castShadow
				receiveShadow
				geometry={nodes.star.geometry}
				rotation={[0, Math.PI, 0]}
				onPointerDown={onClick}
			>
				<meshStandardMaterial color={color} transparent opacity={opacity} />
			</mesh>
			}
		</group>
	)
}
